function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-9bb00728-b833-4b89-b78c-ec41c41bd681",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m16.268,26.418c-.48,0-.954-.164-1.346-.481l-4.979-4.032h-4.342c-1.644,0-2.982-1.338-2.982-2.982v-5.874c0-1.644,1.338-2.982,2.982-2.982h4.376l4.945-4.004c.649-.525,1.521-.629,2.275-.269.754.36,1.223,1.103,1.223,1.938v16.536c0,.835-.469,1.578-1.223,1.938-.298.142-.615.212-.929.212ZM5.601,12.567c-.266,0-.482.216-.482.482v5.874c0,.266.216.482.482.482h5.227l5.092,4.123v-15.056l-5.057,4.095h-5.262Zm10.895-4.561h0,0Z",
    style: {
      fill: "#e7e7e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.249,24.024c-.428,0-.845-.22-1.078-.616-.351-.595-.152-1.361.442-1.711,2.016-1.188,3.268-3.371,3.268-5.697s-1.252-4.51-3.268-5.697c-.595-.351-.793-1.117-.443-1.711s1.116-.794,1.711-.443c2.775,1.634,4.499,4.643,4.499,7.852s-1.724,6.216-4.499,7.852c-.199.117-.418.173-.633.173Z",
    style: {
      fill: "#e7e7e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.07,21.119c-.581,0-1.101-.407-1.223-.998-.14-.676.295-1.337.971-1.477,1.246-.258,2.15-1.37,2.15-2.645s-.904-2.387-2.15-2.645c-.676-.14-1.111-.801-.971-1.477.14-.676.8-1.111,1.477-.971,2.401.497,4.144,2.639,4.144,5.093s-1.743,4.596-4.144,5.093c-.085.018-.171.026-.254.026Z",
    style: {
      fill: "#e7e7e7"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/Speaker.8c273dd7c7a57206943a271f77bd13cc.svg";
export { ForwardRef as ReactComponent };